import React, { Component } from 'react';
import "./contact.css"
import Config from '../../../config/config.js';


class Contact extends Component {
    render() {
        return (

            <section id="contact" className="padding_top">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 text-center">
                            <div className="heading-title heading_space wow fadeInUp" data-wow-delay="300ms">
                                <span>Let's Get In Touch</span>
                                <h2 className="darkcolor bottom30">Contact Tele Go</h2>
                                <p>It’s the first step towards digitalizing your idea into reality. <br></br>Always happy to hear from you.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12 margin_bottom wow fadeInUp" data-wow-delay="350ms">
                            <div className="row">
                                <div className="col-md-6 col-sm-6 our-address top40">
                                    <h5 className="bottom25">Address</h5>
                                    <p className="bottom15">Bratstva i jedinstva 63/123 , <span className="block">Podgorica Montenegro</span> </p>
                                    <a className="pickus" target="_blank" rel="noopener noreferrer" href="https://www.google.com/maps/dir/?api=1&destination=Bratstva+i+jedinstva+63,+Podgorica,+Montenegro" data-text="Get Directions">Get Directions</a>
                                </div>

                                <div className="col-md-6 col-sm-6 our-address top40">
                                    <h5 className="bottom25">Email</h5>
                                    <p className="bottom15">Office: info@telego.rs<br></br>Support: support@telego.com </p>

                                    <a className="pickus" href="mailto:info@telego.rs" target="_top" data-text="Send a Message">Send a Message</a>
                                </div>
                                {/*<div className="col-md-6 col-sm-6 our-address top40">*/}
                                    {/*<h5 className="bottom25">Support Email</h5>*/}
                                    {/*<p className="bottom15">support@telego.com</p>*/}
                                    {/*<a className="pickus" href="mailto:support@telego.rs" target="_top" data-text="Open a Ticket">Open a Ticket</a>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12 margin_bottom">
                            <form className="getin_form wow fadeInUp" data-wow-delay="400ms" data-url={Config.API_MAIL_URL + Config.API_ACTION_CONTACT} onSubmit={(e) => {this.doSomething(); e.preventDefault();}} action="">
                                <div className="row">

                                    <div id="response" className="footer-msg-response"></div>

                                    <div className="col-md-6 col-sm-6">
                                        <div className="form-group bottom35">
                                            <input className="form-control" type="text" placeholder="First Name:" required id="first_name" name="first_name"/>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="form-group bottom35">
                                            <input className="form-control" type="text" placeholder="Last Name:" required id="last_name" name="last_name"/>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="form-group bottom35">
                                            <input className="form-control" type="email" placeholder="Email:" required id="email" name="email"/>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="form-group bottom35">
                                            <input className="form-control" type="tel" placeholder="Phone:" id="phone" name="phone"/>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <div className="form-group bottom35">
                                            <textarea className="form-control" placeholder="Message" id="message" name="message"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <button type="submit" className="button btnprimary" id="submit_btn">send</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            
        );
    }
}

export default Contact;
